import Loader from "@/atoms-react/loader/Loader.react";
import { Base, SectionTitle } from "@/atoms-react/text/Text.react";
import { useKypay } from "@/features/kypay/hooks/use-kypay";
import { TransactionsList } from "@/views/kypay/components/transaction-list/transaction-list.react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Pagination } from "./pagination";

export const Transactions = () => {
  const { getTransactions } = useKypay();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { data: transactions, isPending: isKypayLoading } = getTransactions({
    page: page ?? 1,
    limit: limit ?? 10
  });
  const [search] = useState<string>("");
  const { t } = useTranslation(["wallet", "atoms"]);
  return (
    <>
      <div className="p-2">
        <SectionTitle className="mb-4">{t("kypay.title_transactions")}</SectionTitle>
        <div className="w-full overflow-x-auto xl:overflow-x-hidden">
          <div
            className={
              "hidden min-w-sm flex-row border-b-2 border-b-slate-50 px-8 text-slate-200 md:flex xl:min-w-0 dark:border-b-slate-800"
            }
          >
            <div className={"w-full basis-1/5 py-2 font-medium text-slate-300 lg:min-w-[200px]"}>
              Type{" "}
            </div>
            <div className={"basis-1/5 py-2 font-medium text-slate-300 lg:min-w-[200px]"}>
              {t("atoms:molecules.coin_layout.header_date")}
            </div>
            <div className={"basis-1/5 py-2 font-medium text-slate-300 lg:min-w-[200px]"}>
              {t("atoms:molecules.coin_layout.header_from")}
            </div>
            <div className={"basis-1/5 py-2 font-medium text-slate-300 lg:min-w-[200px]"}>
              {t("atoms:molecules.coin_layout.header_to")}
            </div>
            <div
              className={"basis-1/5 py-2 text-left md:text-center lg:min-w-[200px] xl:text-right"}
            >
              <Base className="w-full font-medium text-slate-300 xl:w-[200px]">
                {" "}
                {t("atoms:molecules.coin_layout.header_amount")}
              </Base>
            </div>
          </div>

          {isKypayLoading && (
            <div className="my-16 flex w-full flex-col items-center space-y-4">
              <Loader />{" "}
            </div>
          )}

          {!isKypayLoading && (
            <TransactionsList transactions={transactions?.transactions ?? []} search={search} />
          )}
          {!isKypayLoading && (
            <Pagination
              currentPage={page}
              count={transactions?.count ?? 0}
              handlePrev={() => {
                if (page > 1) {
                  setPage(page - 1);
                }
              }}
              setLimit={(value: number) => setLimit(value)}
              limit={limit}
              totalPages={transactions?.count ? Math.ceil(transactions?.count / limit) : 1}
              onClick={(page: number) => {
                setPage(page);
              }}
              handleNext={() => {
                const maxPage = transactions?.count ? Math.ceil(transactions?.count / limit) : 1;
                if (page < maxPage) {
                  setPage(page + 1);
                }
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};
